const footerColumns = [
  {
    title: '产品',
    links: [
      { label: '核心功能', href: '/#features' },
      { label: '数据看板', href: '/#dashboard' },
      { label: '价格方案', href: '/pricing' },
      { label: '登录后台', href: '/login' },
    ],
  },
  {
    title: '资源',
    links: [
      { label: '添加站点', href: '/sites/new' },
      { label: '接入指南', href: '/sites/new' },
      { label: '实时访客', href: '/dashboard/realtime' },
      { label: '免费注册', href: '/register' },
    ],
  },
  {
    title: '公司',
    links: [
      { label: '关于我们', href: '/about' },
      { label: '联系我们', href: 'mailto:hello@statflow.example.com' },
      { label: '服务条款', href: '/terms' },
      { label: '隐私政策', href: '/privacy' },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full px-4 md:px-6 pt-14 pb-8 bg-secondary-100">
      <div className="mx-auto max-w-7xl">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8">
          <div className="md:col-span-2">
            <a href="/" className="flex items-center gap-2.5">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-pulse-line text-lg" />
              </span>
              <span className="font-heading text-xl font-semibold text-foreground-950">
                StatFlow
              </span>
            </a>
            <p className="mt-4 text-sm text-foreground-600 leading-relaxed max-w-xs">
              轻量级的网站流量统计平台，帮你一眼看懂谁在访问、从哪来，让每一次访问都变成可用的洞察。
            </p>
            <div className="mt-5 flex items-center gap-3">
              <a
                href="mailto:hello@statflow.example.com"
                className="w-9 h-9 flex items-center justify-center rounded-md bg-background-50 border border-background-200 text-foreground-600 hover:text-primary-600 hover:border-primary-300 transition-colors"
                aria-label="邮箱"
              >
                <i className="ri-mail-line text-base" />
              </a>
            </div>
          </div>

          {footerColumns.map((col) => (
            <div key={col.title}>
              <h4 className="text-sm font-semibold text-foreground-900">{col.title}</h4>
              <ul className="mt-4 flex flex-col gap-3">
                {col.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors whitespace-nowrap"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            © 2026 StatFlow. 保留所有权利。
          </p>
          <p className="text-xs text-foreground-500">用心统计每一次访问</p>
        </div>
      </div>
    </footer>
  );
}